import useSWR from "swr";

import { api, createGetParkedBasketsUrl } from "@is/services";
import { ParkedBasket } from "@is/types";

export const useParkedBaskets = () => {
  const url = createGetParkedBasketsUrl();
  const { data, error, isLoading } = useSWR(url, api.get);

  return {
    parkedBaskets: (data as ParkedBasket[]) || null,
    error,
    isLoading,
  };
};
